<template>
  <div>
    <loader v-if="loading" />
    <template v-else>
      <div>
        <!-- Info Guide -->
        <info-guide
          v-if="guideVisibleFirstTime"
          type="marketingBudgetExamples"
          visible
          @click="closeInfoFirstTime"
        />
        <!-- /Info Guide -->
        <div class="d-flex justify-content-end margin-guide-not-visible" />
      </div>
    </template>

    <!-- Marketing Costs Tabs -->
    <marketing-costs-tabs v-if="!loading" class="mb-4" />
    <!-- /Marketing Costs Tabs -->

    <!-- Marketing Costs List -->
    <marketing-costs-list class="mb-4" :disabled="aiTemplateLoader" />
    <!-- /Marketing Costs List -->

    <!-- Add More Details -->
    <add-more-details
      v-if="!loading"
      :category="'forecast'"
      :step="'marketing-budget'"
      :concept-name="'marketingBudgetMoreDetails'"
      :completed-step-name="'marketingBudgetCompleted'"
    />
    <!-- /Add More Details -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="marketingBudgetExamples"
      :visible="guideVisible"
      @close="guideVisible = false;"
    />
    <!-- /Info Guide Drawer -->

    <!-- Ai Buddy Drawer -->
    <ai-buddy-drawer
      :visible="aiBuddyDrawerVisible"
      type="marketing-budget"
      @close="aiBuddyDrawerVisible = false"
    />
    <!-- /Ai Buddy Drawer -->
  </div>
</template>

<script>
import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails.vue'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import EventBus from '@/event-bus'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'
import Loader from '@/components/Loader'
import MarketingCostsList from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/MarketingCost/MarketingCostsList.vue'
import MarketingCostsTabs from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/MarketingCost/MarketingCostsTabs.vue'
import MixinAiBuddyDrawer from '@/mixins/aiBuddyDrawer'
import MixinAiTemplate from '@/mixins/aiTemplate'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'

export default {
  name: 'ExpensesMarketingCosts',

  components: {
    MarketingCostsList,
    AddMoreDetails,
    MarketingCostsTabs,
    InfoGuide,
    AiBuddyDrawer,
    InfoGuideDrawer,
    Loader
  },

  mixins: [MixinApiCalculations, MixinGuide, MixinIdeaRoles, MixinAiBuddyDrawer, MixinAiTemplate],

  data () {
    return {
      loading: false,
      dialogAddNewVisible: false
    }
  },

  mounted () {
    this.openGuide('marketingBudgetFinancialPlanGuide')

    EventBus.$on('loading', (payload) => {
      this.loading = payload
    })

    EventBus.$on('open-info', () => {
      this.guideVisible = true
    })

    EventBus.$on('close-info-first-time', () => {
      this.guideVisibleFirstTime = false
    })
  },

  beforeDestroy () {
    EventBus.$off('loading')
    EventBus.$off('open-info')
    EventBus.$off('close-info-first-time')
  }
}
</script>
